import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../domain/theme';

const styles = {
  main: css`
    font-size: ${theme.font.size('l')};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: ${theme.line.height('base')};
    letter-spacing: ${theme.letterSpacing('xs2')};
    color: #000;
    ${theme.font.family('regularWeb')};
    margin-top: ${theme.spacing('xs')};
    ${theme.mq.tablet} {
      margin-top: ${theme.spacing('s')};
    }
  `
};

export const SubHeadline = ({ children }) => {
  return <h2 css={styles.main}>{children}</h2>;
};

SubHeadline.propTypes = {
  children: PropTypes.node.isRequired
};
